import { RemoveUsersFromMultipleTagsCardShared } from '@scale/genai-compass-shared/cards/remove_users_from_multiple_tags';
import { makeAutoOpsCardUI } from '../constants';
import { faUserMinus } from '@fortawesome/pro-solid-svg-icons';

export const RemoveUsersFromMultipleTagsCardUI = makeAutoOpsCardUI(
  RemoveUsersFromMultipleTagsCardShared,
  { button: { icon: faUserMinus }, isLegacy: true, ownerTeam: 'Pay / Growth' },
);
